// This is for SHARED (aka PUBLIC) constants, that are ok to be exposed on the audience app.
export const CURRENCIES = [
  'all',
  'amd',
  'aud',
  'azn',
  'chf',
  'czk',
  'dkk',
  'eur',
  'gbp',
  'gel',
  'ils',
  'isk',
  'mdl',
  'nok',
  'pln',
  'ron',
  'rsd',
  'sek',
  'uah',
] as const

// INFO: An EBU member broadcaster, representing a nation,
// sending a Contestant to the contest. These are the countries that can be voted for.
// Identified by a two/three-letter ISO code.
// These are the only countries votes can be stored on.
export const PARTICIPATING_COUNTRIES = [
  'AL',
  'AM',
  'AT',
  'AU',
  'AZ',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'FI',
  'FR',
  'GB',
  'GE',
  'GR',
  'HR',
  'IL',
  'IT',
  'LT',
  'LU',
  'LV',
  'ME',
  'MD',
  'MT',
  'NO',
  'PL',
  'PT',
  'RO',
  'RS',
  'SE',
  'SM',
  'UA',
] as const
